module.exports = __webpack_public_path__ + "app-store-black.svg?7c7b0a0f04d538cc7c08467c75e46c5c";